export const SEARCH_FORM_PLACEHOLDER = 'search-form.placeholder';
export const SEARCH_FORM_SUBMIT_BUTTON_LABEL = 'search-form.submit-button-label';
